export default {
    tabs: [
      { to: '/home', icon: 'mdi-home', label: 'ホーム' },
      { to: '/members', icon: 'mdi-account-group', label: 'メンバー' },
      { to: '/access', icon: 'mdi-map-marker-outline', label: 'アクセス' },
      { to: '/research', icon: 'mdi-flask', label: '研究' },
      { to: '/facility', icon: 'mdi-sofa', label: '設備' },
      { to: '/publications', icon: 'mdi-file-document-multiple-outline', label: '発表文献' }
    ],
  }